import { API_DOMAIN } from '../../config'
import { fetchData } from '../../util/index'
import { CLUB_ID } from '../ClubBusiness/constants'
import { GET_SUMMARY, GET_DETAIL } from './constants'
import { OK } from '../CheckOutAdvManage/constants'
import { message } from 'antd'

const exportHeaders = {
  Authorisation: sessionStorage.getItem('s'),
  'Club-Id': sessionStorage.getItem(CLUB_ID) || '',
}

function downloadBlob(url, filename) {
  return fetch(url, { headers: exportHeaders })
    .then((res) => res.blob())
    .then((blob) => {
      const downloadUrl = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = downloadUrl
      a.download = filename
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      window.URL.revokeObjectURL(downloadUrl)
    })
}

export const fetchSummary = (params) => (dispatch) => {
  const query = new URLSearchParams()
  if (params.startDate) query.append('startDate', params.startDate)
  if (params.endDate) query.append('endDate', params.endDate)
  if (params.type !== undefined && params.type !== '') query.append('type', params.type)
  if (params.groupBy) query.append('groupBy', params.groupBy)
  if (params.statisticType) query.append('statisticType', params.statisticType)
  const endpoint = `${API_DOMAIN}/Home/TableUsageStatisticsApi/summary?${query.toString()}`
  return fetchData(endpoint).then((data) => {
    if (data.status === OK) {
      dispatch({ type: GET_SUMMARY, payload: data })
    } else {
      message.error(data.detail + '')
    }
    return data
  })
}

export const exportSummary = (params) => () => {
  const query = new URLSearchParams()
  if (params.startDate) query.append('startDate', params.startDate)
  if (params.endDate) query.append('endDate', params.endDate)
  if (params.type !== undefined && params.type !== '') query.append('type', params.type)
  if (params.groupBy) query.append('groupBy', params.groupBy)
  if (params.statisticType) query.append('statisticType', params.statisticType)
  return downloadBlob(
    `${API_DOMAIN}/Home/TableUsageStatisticsApi/export?${query.toString()}`,
    `桌台使用时长汇总_${params.startDate}_${params.endDate}.xlsx`
  )
}

export const fetchDetail = (params) => (dispatch) => {
  const query = new URLSearchParams()
  if (params.startDate) query.append('startDate', params.startDate)
  if (params.endDate) query.append('endDate', params.endDate)
  if (params.type !== undefined && params.type !== '') query.append('type', params.type)
  if (params.tableName) query.append('tableName', params.tableName)
  if (params.page) query.append('page', params.page)
  if (params.size) query.append('size', params.size)
  if (params.statisticType) query.append('statisticType', params.statisticType)
  const endpoint = `${API_DOMAIN}/Home/TableUsageStatisticsApi/detail?${query.toString()}`
  return fetchData(endpoint).then((data) => {
    if (data.status === OK) {
      dispatch({ type: GET_DETAIL, payload: data })
    } else {
      message.error(data.detail + '')
    }
    return data
  })
}

export const exportDetail = (params) => () => {
  const query = new URLSearchParams()
  if (params.startDate) query.append('startDate', params.startDate)
  if (params.endDate) query.append('endDate', params.endDate)
  if (params.type !== undefined && params.type !== '') query.append('type', params.type)
  if (params.tableName) query.append('tableName', params.tableName)
  if (params.statisticType) query.append('statisticType', params.statisticType)
  return downloadBlob(
    `${API_DOMAIN}/Home/TableUsageStatisticsApi/exportDetail?${query.toString()}`,
    `桌台使用时长明细_${params.startDate}_${params.endDate}.xlsx`
  )
}



// WEBPACK FOOTER //
// ./src/containers/TableUsageStatistics/action.js